import type { AxiosRequestConfig, AxiosResponse } from 'axios';
import axios from 'axios';

import { decodeError as decodeErrorUtility } from '@genially/utils';

type UtilityDecodedError = ReturnType<typeof decodeErrorUtility>;

export type DecodedError = UtilityDecodedError &
  (
    | {
        isAxiosError: false;
      }
    | {
        isAxiosError: true;

        config: {
          timeout?: number;
          maxBodyLength?: number;
          maxContentLength?: number;
        };

        request: AxiosRequestConfig;

        response: {
          status?: number;
          statusText?: string;
          headers?: AxiosResponse['headers'];
          data?: unknown;
        };
      }
  );

/**
 * Try to decode an error into a message and a stack.
 * Also, if the error is an Axios error, it will include the request and response data.
 * @param error
 */
export const decodeError = (error: unknown): DecodedError => {
  if (axios.isAxiosError(error)) {
    return {
      message: `[Axios error] Code: ${error.code} - Message: ${error.message}`,
      stack: error.stack,
      isAxiosError: true,

      config: {
        timeout: error.config?.timeout,
        maxBodyLength: error.config?.maxBodyLength,
        maxContentLength: error.config?.maxContentLength,
      },

      request: {
        method: error.config?.method,
        url: error.config?.url,
        headers: error.config?.headers,
        withCredentials: error.config?.withCredentials,
        data: error.config?.data,
      },

      response: {
        status: error.response?.status,
        statusText: error.response?.statusText,
        headers: error.response?.headers,
        data: error.response?.data,
      },
    };
  }

  return {
    ...decodeErrorUtility(error),
    isAxiosError: false,
  };
};
